import {
  getToken,
  removeToken,
  setToken
} from "@/utils/auth";
const state = {
  token: getToken()

};
const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
};
const actions = {
  resetToken({
    commit
  }) {
    return new Promise(resolve => {
      commit("SET_TOKEN", '');
      removeToken()
      resolve()
    })
  },
  setToken({
    commit
  }, result) {
    return new Promise(resolve => {
      commit("SET_TOKEN", result);
      setToken(result.token)
      resolve()
    })
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};